export function isAnnouncementsEnabled(): boolean {
  const isNonProduction = import.meta.env.MODE !== 'production';
  const hasCookie = document.cookie
    .split('; ')
    .some((cookie) => cookie === 'announcements_enabled=true');

  return isNonProduction && hasCookie;
}
